/**
 * Created by Owner on 2016/8/6.
 * 直选组合
 *  selectArea: {
          layout: [
            {
              title: "千位",
              no: "0|1|2|3|4|5|6|7|8|9"
            },
            {
              title: "万位",
              no: "0|1|2|3|4|5|6|7|8|9"
            },
            {
              title: "千位",
              no: "0|1|2|3|4|5|6|7|8|9"
            },
            {
              title: "百位",
              no: "0|1|2|3|4|5|6|7|8|9"
            }
          ],
          noBigIndex: 5
 */
import {Component} from '@angular/core';
import {LotteryMathZXFSComponent} from "./zxfs";
import {LotteryMath} from "./lotteryMath";
import {ArrayUtil} from "../../util/arrayUtil";

@Component({
  selector: 'lottery-math-ltzx',
  templateUrl: 'selectMath.html',
})
export class LotteryMathLTZXHComponent extends LotteryMathZXFSComponent implements LotteryMath {
  ngOnInit() {
  }

  optionFn = {
    "LTZX3": (data_sel)=>this.method3(data_sel),
    "LTZX2": (data_sel)=>this.method2(data_sel),
    "PK_JZQ3": (data_sel)=>this.method3(data_sel),
    "PK_JZQ2": (data_sel)=>this.method2(data_sel),
    "PK_JZQ4": function (data_sel) {
      let nums: number = 0;
      if (data_sel[0].length > 0 && data_sel[1].length > 0 && data_sel[2].length > 0 && data_sel[3].length > 0) {
        for (let i = 0; i < data_sel[0].length; i++) {
          for (let j = 0; j < data_sel[1].length; j++) {
            for (let k = 0; k < data_sel[2].length; k++) {
              for (let L = 0; L < data_sel[3].length; L++) {
                if (data_sel[0][i] != data_sel[1][j] && data_sel[0][i] != data_sel[2][k]
                  && data_sel[0][i] != data_sel[3][L] && data_sel[1][j] != data_sel[2][k] && data_sel[1][j] != data_sel[3][L] && data_sel[2][k] != data_sel[3][L]) {
                  nums++
                }
              }
            }
          }
        }
      }
      return nums;
    }
  }

  changeTotal() {
    let mname = this.selectAreaOption["mname"];
    let tmpTotal: number = 1;
    let data_sel: any = [];
    this.children.toArray().forEach(child=> {
      data_sel.push(child.selectNo);
    });
    tmpTotal = this.optionFn[mname](data_sel);
    this.setTotal(tmpTotal);
  }

  method3(data_sel) {
    let nums: number = 0;
    if (data_sel[0].length > 0 && data_sel[1].length > 0 && data_sel[2].length > 0) {
      for (let i = 0; i < data_sel[0].length; i++) {
        for (let j = 0; j < data_sel[1].length; j++) {
          for (let k = 0; k < data_sel[2].length; k++) {
            if (data_sel[0][i] != data_sel[1][j] && data_sel[0][i] != data_sel[2][k] && data_sel[1][j] != data_sel[2][k]) {
              nums++;
            }
          }
        }
      }
    }
    return nums;
  }

  method2(data_sel) {
    let nums: number = 0;
    if (data_sel[0].length > 0 && data_sel[1].length > 0) {
      var h = ArrayUtil.intersect(data_sel[0], data_sel[1]).length;
      nums = data_sel[0].length * data_sel[1].length - h;
    }
    return nums;
  }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/ltzx.ts